var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeClosed = function SvgEyeClosed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C10.866 9 12.9414 6.95339 14 5.5C12.9414 4.04661 10.866 2 7 2C3.13401 2 1.20988 3.83898 0 5.5C1.08025 6.98305 3.13401 9 7 9ZM7.21737 8.69564C8.98228 8.69564 10.413 7.2649 10.413 5.49999C10.413 3.73508 8.98228 2.30434 7.21737 2.30434C5.45246 2.30434 4.02172 3.73508 4.02172 5.49999C4.02172 7.2649 5.45246 8.69564 7.21737 8.69564Z",
    fill: "#4D4D4F",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21733 8.08694C8.64606 8.08694 9.80428 6.92872 9.80428 5.49998C9.80428 4.07124 8.64606 2.91302 7.21733 2.91302C6.97849 2.91302 6.74721 2.94539 6.52764 3.00598C6.8505 3.16007 7.07358 3.48956 7.07358 3.87116C7.07358 4.40032 6.64461 4.8293 6.11545 4.8293C5.60686 4.8293 5.19082 4.43302 5.15924 3.93239C4.82743 4.36736 4.63037 4.91066 4.63037 5.49998C4.63037 6.92872 5.78859 8.08694 7.21733 8.08694Z",
    fill: "#4D4D4F",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5L13.5 11",
    stroke: "#CACACA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye-closed.731532c3.svg";
export { ForwardRef as ReactComponent };